export default __webpack_public_path__ + "static/media/arrow.094c6d85.svg";